module.exports = __webpack_public_path__ + "static/data/template.344c1fa.json";